module.exports = __webpack_public_path__ + "img/green3.5e5572a8.jpg";